import {withFormsy} from 'formsy-react';
import React, {useState} from 'react';
import Switch from "react-switch";

let SettingFormInput = (props) => {

    const [formId, setFormId] = useState(TB.guid())

    return (
        <div className="form-group setting-form-group">
            <label htmlFor={formId} className="mx-2 flex flex-row items-center justify-start">
                <Switch
                    name={props.name}
                    checked={!!props.value}
                    height={20}
                    width={40}
                    onChange={(checked) =>  props.setValue(checked)}
                    onColor={TB.config('color.light_purple')}
                    offColor={'#e7e7e8'}
                    uncheckedIcon={false}
                    checkedIcon={(<i className="fa fa-check text-white"/>)}
                    activeBoxShadow={'0 0 1px 2px ' + TB.config('color.light_purple')}
                    className="react-switch"
                    id={formId}
                    disabled={props.disabled}
                />
            </label>

        </div>
    )
};

const SettingInput = withFormsy(SettingFormInput);

export default SettingInput;